import { Component, Input } from '@angular/core';
import { AutoCurateModalComponent } from 'src/app/components/modal/auto-curate-modal/auto-curate-modal.component';
import { ModalService } from 'src/app/components/modal/modal.service';

@Component({
    selector: 'app-ta-type-auto-curate',
    templateUrl: './ta-type-auto-curate.component.html',
    styleUrls: ['./ta-type-auto-curate.component.scss'],
})
export class TaTypeAutoCurateComponent {
    @Input() callbackData: any;

    constructor(private modal: ModalService) {}

    ngOnInit() {
        console.log('DATA RECEIVED', this.callbackData);
    }

    showModal() {
        this.modal.openModal({
            component: AutoCurateModalComponent,
            data: this.callbackData,
            prefix: 'audit-data',
        });
    }
}
